import { render } from "./AnoneTitle.vue?vue&type=template&id=13d6c1a5&scoped=true"
const script = {}

import "./AnoneTitle.vue?vue&type=style&index=0&id=13d6c1a5&scoped=true&lang=css"

import exportComponent from "/Users/wadayuki/Desktop/anone/anone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d6c1a5"]])

export default __exports__